<template>
  <v-container
    class="d-flex justify-center align-center flex-column"
    style="height: 80vh"
  >
    <router-link to="/">
      <img
        width="350"
        height="auto"
        :src="require('@/assets/images/logos/logo.png')"
      />
    </router-link>
    <v-card
      :loading="submitting"
      :disabled="submitting"
      class="mx-auto my-5"
      width="500"
      outlined
    >
      <div class="text-center ma-5">
        <section v-if="ret && ret.status === 200">
          <!-- <p class="text-h6 grey--text">Forgot your password?</p> -->
          <p class="text-subtitle-1 success--text">
            We sent a recovery link to you at
          </p>
          <p class="text-subtitle-1" v-html="ret.data"></p>
        </section>
        <section v-else>
          <v-form ref="form" @submit.prevent="submitLink">
            <v-alert outlined type="error" v-if="ret">
              <span v-html="ret.data"></span>
            </v-alert>
            <p class="text-h6 grey--text">Forgot your password?</p>
            <v-text-field
              v-model="userName"
              label="Please enter your User Name or Email"
              outlined
              hide-details="auto"
              :rules="[(v) => !!v || 'This field is required.']"
            ></v-text-field>
            <v-btn color="primary" type="submit" class="my-5 text-none" block>
              Send recovery link
            </v-btn>
          </v-form>
        </section>
        <v-divider class="my-3"></v-divider>
        <router-link to="/sign-in" class="text-decoration-none text-center">
          Return to sign in
        </router-link>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "SendRecoveryLink",
  data() {
    return {
      submitting: false,
      userName: null,
      ret: null,
    };
  },
  methods: {
    async submitLink() {
      if (this.$refs.form.validate()) {
        this.submitting = true;

        this.ret = await this.$store
          .dispatch("authentication/sendRecoveryLink", {
            userName: this.userName,
          })
          .catch((err) => err.response);

        this.submitting = false;
      }
    },
  },
};
</script>
